import { $themeBreakpoints } from '@themeConfig'
import { ApiCode } from '@/const/api'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    organizationProperty: {
      logo: '',
      orgCode: '',
      orgName: '',
      courseSemesterShowable: true,
    },
    isOrgDataLoaded: false,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_ORGANIZATION_PROPERTY(state, val) {
      state.organizationProperty = { ...val }
      state.isOrgDataLoaded = true
    },
  },
  actions: {
    async getOrganizationProperty({ commit }) {
      const response = await axios.get('uni/organizationProperties/getAllProperties')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const faviconLink = document.createElement('link')
        faviconLink.id = 'favicon'
        faviconLink.rel = 'icon'
        faviconLink.href = data.data.logo || '/favicon.ico'
        document.head.appendChild(faviconLink)

        commit('UPDATE_ORGANIZATION_PROPERTY', data.data)
      } else {
        const faviconLink = document.createElement('link')
        faviconLink.id = 'favicon'
        faviconLink.rel = 'icon'
        faviconLink.href = '/favicon.ico'
        document.head.appendChild(faviconLink)
      }
    },
  },
}
